export default __webpack_public_path__ + "static/media/padel-suix.39b80698.png";